<!-- =========================================================================================
  File Name: StudentEditTabInformation.vue
  Description: Student Edit Information Tab content
  ----------------------------------------------------------------------------------------
  Item Name: Vuexy - Vuejs, HTML & Laravel Admin Dashboard Template
  Author: Pixinvent
  Author URL: http://www.themeforest.net/user/pixinvent
========================================================================================== -->

<template>
  <div>
    <!-- Avatar Row -->
    <div class="vx-row">
      <div class="mb-4 vx-col w-full">
        <div class="flex items-start flex-col sm:flex-row">
          <img :src="student_data.photo" class="mr-8 rounded h-24 w-24" />
          <!-- <vs-avatar :src="data.avatar" size="80px" class="mr-4" /> -->
          <div>
            <p class="text-lg font-medium mb-2 mt-4 sm:mt-0">{{ student_data.name  }}( {{ student_data.studentID  }} )</p>
            <input type="file" class="hidden" ref="update_photo_input" @change="update_photo" accept="image/*">

            <!-- Toggle comment of below buttons as one for actual flow & currently shown is only for demo -->
            <vs-button class="mb-4" color="rgb(62, 201, 214)">파일선택</vs-button>
          </div>
        </div>
      </div>
    </div>
    <!-- Content Row -->
    <div class="vx-row"> 
      <div class="vx-col md:w-1/2 w-full">
        <vs-input class="w-full mt-4 mb-4" label="영문이름" v-model="student_data.engName" name="engName" />
        <span class="text-danger text-sm" v-show="errors.has('engName')">{{ errors.first('engName') }}</span>
        
        <label class="w-full ml-2 text-sm">학년구분</label>
        <div class="flex">
          <div class="mr-2 w-1/2 bg-grid-color-secondary h-12">
            <vs-select v-model="student_data.schoolType" class="w-full" name="item-schoolType" >
              <vs-select-item :key="item.value" :value="item.value" :text="item.text" v-for="item in schoolTypeOptions" />
            </vs-select>
            <span class="text-danger text-sm" v-show="errors.has('item-schoolType')">{{ errors.first('item-schoolType') }}</span>
          </div>
          <div class="ml-2 w-1/2 bg-grid-color h-12">
            <!-- <vs-input class="w-full" v-model="student_data.schoolGrade "  name="schoolGrade" />
            <span class="text-danger text-sm" v-show="errors.has('schoolGrade')">{{ errors.first('schoolGrade') }}</span> -->
            <vs-select v-model="student_data.schoolGrade" class="w-full" name="item-schoolGrade" >
              <vs-select-item :key="item.value" :value="item.value" :text="item.text" v-for="item in schoolGradeOptions" />
            </vs-select>
            <span class="text-danger text-sm" v-show="errors.has('item-schoolGrade')">{{ errors.first('item-schoolGrade') }}</span>
         
          </div>
        </div>
        
        <vs-input class="w-full mt-2" label="학교명" v-model="student_data.schoolName"  name="schoolName" />
        <span class="text-danger text-sm" v-show="errors.has('schoolName')">{{ errors.first('schoolName') }}</span>

        <vs-input class="w-full mt-4" label="학생 휴대폰번호" v-model="student_data.mobilephone "  name="mobilephone" />
        <span class="text-danger text-sm" v-show="errors.has('mobilephone')">{{ errors.first('mobilephone') }}</span>

        <vs-input class="w-full mt-4" label="모 휴대폰번호" v-model="student_data.motherMobile "  name="motherMobile" />
        <span class="text-danger text-sm" v-show="errors.has('motherMobile')">{{ errors.first('motherMobile') }}</span>

        <vs-input class="w-full mt-4" label="부 휴대폰" v-model="student_data.fatherMobile " name="fatherMobile" />
        <span class="text-danger text-sm" v-show="errors.has('fatherMobile')">{{ errors.first('fatherMobile') }}</span>

        <vs-input class="w-full mt-4 mb-4" label="전화번호" v-model="student_data.telephone" name="telephone" />
        <span class="text-danger text-sm" v-show="errors.has('telephone')">{{ errors.first('telephone') }}</span>

        <label class="mt-4 ml-2 text-sm">생년월일</label>
        <div class="flex">
          <div class="w-1/3 bg-grid-color-secondary h-12">
            <datepicker :language="languages.ko" @selected="formatterBirthDay" v-model="student_data.birthDay" v-validate="'required'" format="yyyy-MM-dd"></datepicker>
            <span class="text-danger text-sm"></span>
          </div>
          <div class="ml-4 w-1/3 bg-grid-color h-12">
            <div>
              <vs-select v-model="student_data.isLunar" label="" class="w-full" name="item-isLunar" >
                <vs-select-item :key="item.value" :value="item.value" :text="item.text" v-for="item in isLunarOptions" />
              </vs-select>
              <span class="text-danger text-sm" v-show="errors.has('item-isLunar')">{{ errors.first('item-isLunar') }}</span>
            </div>
          </div>
          <div class="ml-4 w-1/3 bg-grid-color h-12">
            <div>
              <vs-select v-model="student_data.gender" label="" class="w-full" name="item-gender" >
                <vs-select-item :key="item.value" :value="item.value" :text="item.text" v-for="item in genderOptions" />
              </vs-select>
              <span class="text-danger text-sm" v-show="errors.has('item-gender')">{{ errors.first('item-gender') }}</span>
            </div>
          </div>
          <!-- <div class="mt-2 ml-4 w-1/3 bg-grid-color h-12">
            <div>
              <vs-radio v-model="student_data.isLunar" vs-value="0" name="isLunar" class="mr-4">양력</vs-radio>
              <vs-radio v-model="student_data.isLunar" vs-value="1" name="isLunar" class="mr-4">음력</vs-radio>
            </div>
          </div>
          <div class="mt-2 w-1/3 bg-grid-color-secondary h-12">
            <div>
              <vs-radio v-model="student_data.gender" vs-value="0" name="gender" class="mr-4">남</vs-radio>
              <vs-radio v-model="student_data.gender" vs-value="1" name="gender" class="mr-4">여</vs-radio>
            </div>
          </div> -->
        </div>

        <div class="flex flex-wrap mt-4">
          <div class="w-1/2">
            <vs-input class="w-full" label="우편번호" disabled v-model="student_data.zipCode" name="zipCode" />
            <span class="text-danger text-sm" v-show="errors.has('zipCode')">{{ errors.first('zipCode') }}</span>
          </div>
          <div class="w-1/2">
            <vs-button class="mt-5 ml-4" @click="popupActive=true">주소 검색</vs-button>
          </div>
        </div>
       
        <vs-input class="w-full mt-4" label="주소" disabled v-model="student_data.zipName" name="zipName" />
        <span class="text-danger text-sm" v-show="errors.has('zipName')">{{ errors.first('zipName') }}</span>

        <vs-input class="w-full mt-4" label="주소세부" v-model="student_data.zipDetail" name="zipDetail" />
        <span class="text-danger text-sm" v-show="errors.has('zipDetail')">{{ errors.first('zipDetail') }}</span>

      </div>

      <div class="vx-col md:w-1/2 w-full">  
        <!--<vs-input class="w-full mt-4" label="Class 정보" v-model="student_data.classSeq" v-validate="'required'" name="classSeq" />
        <span class="text-danger text-sm" v-show="errors.has('classSeq')">{{ errors.first('classSeq') }}</span>

        <vs-input class="w-full mt-4" label="교사" v-model="student_data.instituteSeq" v-validate="'required'" name="" />
        <span class="text-danger text-sm" v-show="errors.has('')">{{ errors.first('') }}</span>

        <vs-select v-model="student_data.instituteSeq" label="수납 SMS" class="mt-4 w-full" name="item-instituteSeq" v-validate="'required'">
          <vs-select-item :key="item.instituteSeq" :value="item.instituteSeq" :text="item.instituteName" v-for="item in instituteOptions" />
        </vs-select>
        <span class="text-danger text-sm" v-sh-ow="errors.has('item-instituteSeq')">{{ errors.first('item-instituteSeq') }}</span>

        <vs-input class="w-full mt-4" label="현재 포인트" v-model="student_data.zipName" v-validate="'required'" name="zipName" />
        <span class="text-danger text-sm" v-show="errors.has('zipName')">{{ errors.first('zipName') }}</span> -->

        <!-- <vs-select v-model="student_data.smsType" label="수납 SMS" class="mt-4 w-full" name="item-smsType" >
          <vs-select-item :key="item.value" :value="item.value" :text="item.text" v-for="item in smsTypeOptions" />
        </vs-select>
        <span class="text-danger text-sm" v-show="errors.has('item-smsType')">{{ errors.first('item-smsType') }}</span> -->

        <div class="mt-4">  
          <label class="ml-2 text-sm">현재 레벨</label>
          <vs-input-number v-model="student_data.currentLevel" icon-inc="expand_less" icon-dec="expand_more"/>
          <span class="text-danger text-sm" v-show="errors.has('currentLevel')">{{ errors.first('currentLevel') }}</span> 
        </div>

        <div class="mt-4">
          <label class="ml-2 text-sm">입학일</label>
          <datepicker :language="languages.ko" @selected="formatterSchoolEnterDate" v-model="student_data.schoolEnterDate" v-validate="'required'" format="yyyy-MM-dd"></datepicker>
          <span class="text-danger text-sm"></span>
        </div>

        <div class="mt-4">
          <label class="ml-2 text-sm">퇴교일</label>
          <datepicker :language="languages.ko" @selected="formatterSchoolLeaveDate" v-model="student_data.schoolLeaveDate" v-validate="'required'" format="yyyy-MM-dd"></datepicker>
          <span class="text-danger text-sm"></span>
        </div>

        <vs-select v-model="student_data.status" label="상태" class="mt-4 w-full" name="item-status" >
          <vs-select-item :key="item.value" :value="item.value" :text="item.text" v-for="item in statusOptions" />
        </vs-select>
        <span class="text-primary text-sm">퇴교 처리시 수강권한은 자동 회수 됩니다.</span>
        <span class="text-danger text-sm" v-show="errors.has('item-status')">{{ errors.first('item-status') }}</span>

        <vs-select v-model="student_data.licenseYn" label="수강권한" class="mt-4 w-full" name="item-licenseYn" >
          <vs-select-item :key="item.value" :value="item.value" :text="item.text" v-for="item in licenseYnOptions" />
        </vs-select>
        <span class="text-primary text-sm">수강권한이 있는 학생만 학습이 가능합니다.</span>
        <span class="text-danger text-sm" v-show="errors.has('item-licenseYn')">{{ errors.first('item-licenseYn') }}</span>

        <vs-select v-model="student_data.teacherID" label="담당 강사" class="mt-4 w-full" name="item-teacher" >
          <vs-select-item :key="item.teacherID" :value="item.teacherID" :text="item.name" v-for="item in teacherList" />
        </vs-select>

      </div>
    </div>

    <!-- Save & Reset Button -->
    <div class="vx-row">
      <div class="vx-col w-full">
        <div class="mt-8 flex flex-wrap items-center justify-end">
          <vs-button class="ml-auto mt-2" @click="confirmSaveChanges" :disabled="!validateForm">수정</vs-button>
          <!-- <vs-button class="ml-4 mt-2" type="border" color="warning" @click="reset_data">Reset</vs-button> -->
          <vs-button class="ml-4 mt-2" type="border" color="warning" @click="$router.go(-1)">취소</vs-button>
        </div>
      </div>
    </div>

    <!-- Daum 우편번호 서비스 -->
    <vs-popup class="holamundo" title="주소 검색" :active.sync="popupActive">
      <p>
        <vue-daum-postcode @complete="this.daumPostCode" />
      </p>
    </vs-popup>
  </div>
</template>

<script>
import Datepicker from 'vuejs-datepicker'
import * as lang from 'vuejs-datepicker/src/locale'
import vSelect from 'vue-select'
import moment from 'moment'
import { VueDaumPostcode } from 'vue-daum-postcode'

import { fetchData, putData } from '@/api/module'

export default {
  components: {
    vSelect,
    Datepicker,
    VueDaumPostcode
  },
  props: {
    data: {
      type: Object,
      required: true
    }
  },
  data () {
    return { 
      languages: lang,
      popupActive: false,
      student_data: this.data,
      birthDay: this.data.birthDay,
      teacherList: [],
      schoolEnterDate: this.data.schoolEnterDate,
      schoolLeaveDate: this.data.schoolLeaveDate,
      schoolTypeOptions: [
        {
          value: 0,
          text: '초등'
        },
        {
          value: 1,
          text: '중등'
        },
        {
          value: 2,
          text: '고등'
        }
      ],
      schoolGradeOptions: [
        {
          value: 0,
          text: '1학년'
        },
        {
          value: 1,
          text: '2학년'
        },
        {
          value: 2,
          text: '3학년'
        },
        {
          value: 3,
          text: '4학년'
        },
        {
          value: 4,
          text: '5학년'
        },
        {
          value: 5,
          text: '6학년'
        }
      ],
      isLunarOptions: [
        {
          value: 0,
          text: '양력'
        },
        {
          value: 1,
          text: '음력'
        }
      ],
      genderOptions: [
        {
          value: 0,
          text: '남'
        },
        {
          value: 1,
          text: '여'
        }
      ],
      smsTypeOptions: [
        {
          value: 0,
          text: '안함'
        },
        {
          value: 1,
          text: '부핸드폰'
        },
        {
          value: 2,
          text: '모핸드폰'
        }
      ],
      statusOptions: [
        {
          value: 0,
          text: '정상'
        },
        {
          value: 1,
          text: '퇴교'
        }
      ],
      licenseYnOptions: [
        {
          value: 'Y',
          text: '가능'
        },
        {
          value: 'N',
          text: '불가능'
        }
      ]
    }
  },
  computed: {
    validateForm () {
      return !this.errors.any()
    }
  },
  methods: {
    formatterBirthDay (value) {
      
      const birthDay = moment(value).format('YYYY-MM-DD')
      this.birthDay = birthDay
    },
    formatterSchoolEnterDate (value) {
      
      const schoolEnterDate = moment(value).format('YYYY-MM-DD')
      this.schoolEnterDate = schoolEnterDate
    },
    formatterSchoolLeaveDate (value) {
      
      const schoolLeaveDate = moment(value).format('YYYY-MM-DD')
      this.schoolLeaveDate = schoolLeaveDate
    },
    daumPostCode (value) {
      // console.log(`result: ${JSON.stringify(value)}`)
      this.student_data.zipCode = value.zonecode
      this.student_data.zipName = value.address

      this.popupActive = false
    },
    update_photo () {
      // You can update avatar Here
      // For reference you can check dataList example
      // We haven't integrated it here, because data isn't saved in DB
    },
    confirmSaveChanges () {
      this.$vs.dialog({
        type: 'confirm',
        color: 'danger',
        title: '학생 정보 수정',
        text: '저장 하시겠습니까?',
        accept: this.saveChanges,
        acceptText: '저장'
      })
    },
    async saveChanges () {
      if (!this.validateForm) return

      this.student_data.birthDay = this.birthDay
      this.student_data.schoolEnterDate = this.schoolEnterDate
      this.student_data.schoolLeaveDate = this.schoolLeaveDate

      try {
        const { data } = await putData('student', this.student_data)
        console.log(data)

        const studentID = this.student_data.studentID
        this.$router.push(`/student/student-view/${studentID}`)
        this.showSaveChangesSuccess()

      } catch (error) {
        this.$vs.notify({
          title: 'Error',
          text: error.response.data.msg,
          iconPack: 'feather',
          icon: 'icon-alert-circle',
          color: 'danger'
        }) 
      }
    },
    showSaveChangesSuccess () {
      this.$vs.notify({
        color: 'success',
        title: '학생 정보 수정',
        text: '저장 되었습니다.'
      })
    },
    reset_data () {
      this.student_data = JSON.parse(JSON.stringify(this.data))
    },
    async loadItem () {
      try {
        const keyword = ''
        const {data}  = await fetchData('institute/search', keyword)
        // console.log(institutes.data);
        this.instituteOptions = data.list
      } catch (error) {
        this.$vs.notify({
          title: 'Error',
          text: error.response.data.msg,
          iconPack: 'feather',
          icon: 'icon-alert-circle',
          color: 'danger'
        }) 
      }
    },
    async loadTeacher () {
      try {
        const params = {
          instituteSeq: this.student_data.instituteSeq
        }
        const {data}  = await fetchData('teacher/search', params)
        this.teacherList = data.list
        this.teacherList.splice(0, 0, {teacherID: null, name: '[없음]'})
      } catch (error) {
        this.$vs.notify({
          title: 'Error',
          text: error.response.data.msg,
          iconPack: 'feather',
          icon: 'icon-alert-circle',
          color: 'danger'
        }) 
      }
    }
  },
  created () {
    this.loadItem()
  },
  mounted () {
    this.loadTeacher()
  }
}
</script>
